import React from 'react';
import { Ruler as RulerIcon } from 'lucide-react';
import { TamanhoSummary } from './types';
import { TAMANHO_COLORS } from './StatsCard';

type TamanhoTableProps = {
  data: TamanhoSummary[];
};

const defaultColor = {
  bg: 'bg-gray-50',
  border: 'border-gray-200',
  iconBg: 'bg-gray-100',
  iconText: 'text-gray-500',
  barBg: 'bg-gray-100',
  barFill: 'bg-gray-400',
  valueText: 'text-gray-600',
};

export const TamanhoTable: React.FC<TamanhoTableProps> = ({ data }) => {
  const totalCnpjs = data.reduce((sum, r) => sum + r.totalCnpjs, 0);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr className="bg-gray-50">
            <th
              scope="col"
              className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              Tamanho UL
            </th>
            <th
              scope="col"
              className="px-6 py-3.5 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              Total CNPJs
            </th>
            <th
              scope="col"
              className="px-6 py-3.5 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              % do Total
            </th>
            <th
              scope="col"
              className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider w-48"
            >
              Distribuicao
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {data.map((row) => {
            const pct = totalCnpjs > 0 ? (row.totalCnpjs / totalCnpjs) * 100 : 0;
            const color = TAMANHO_COLORS[row.tamanhoUL] ?? defaultColor;

            return (
              <tr
                key={row.tamanhoUL}
                className="bg-white hover:bg-gray-50 transition-colors"
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <div className={`${color.iconBg} ${color.iconText} p-1.5 rounded-lg`}>
                      <RulerIcon className="w-4 h-4" />
                    </div>
                    <span className="text-sm font-medium text-gray-900">
                      {row.tamanhoUL}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right">
                  <span className="text-sm font-semibold text-gray-900">
                    {row.totalCnpjs.toLocaleString('pt-BR')}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right">
                  <span className="text-sm text-gray-600">
                    {pct.toFixed(1)}%
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className={`w-full ${color.barBg} rounded-full h-2`}>
                    <div
                      className={`${color.barFill} h-2 rounded-full transition-all duration-500`}
                      style={{ width: `${Math.min(pct, 100)}%` }}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {data.length === 0 && (
        <div className="flex flex-col items-center justify-center py-16">
          <div className="bg-gray-100 rounded-full p-3 mb-3">
            <RulerIcon className="w-6 h-6 text-gray-400" />
          </div>
          <p className="text-sm text-gray-500">Nenhum tamanho encontrado</p>
        </div>
      )}
    </div>
  );
};
